import { useEffect, useState } from 'react';

import { Box, MenuItem, Select, TextField } from '@mui/material';

import { IQuestion } from 'pages/task/types';

interface FreeTextProps {
  question: IQuestion;
  setAnswer: (key: string) => void;
}

const MultiText = ({ question, setAnswer }: FreeTextProps) => {
  const [formData, setFormData] = useState({
    hospital: '',
    year: '',
    reason: '',
  });

  const setCombineAnswer = () => {
    const { hospital, year, reason } = formData;
    if (hospital !== '' && year !== '' && reason !== '') {
      setAnswer(`${reason}, ${year}, ${hospital}`);
    }
  };

  const years = Array.from({ length: 100 }, (_, index) =>
    (2024 - index).toString()
  );

  useEffect(() => {
    if (typeof question.answer === 'string') {
      const answers = question.answer?.split(',');
      setFormData((prev) => ({
        ...prev,
        reason: answers[0]?.trim() || '',
        year: answers[1]?.trim() || '',
        hospital: answers[2]?.trim() || '',
      }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Box
      data-testid="multi-text-option-component"
      className="d-flex flex-column flex-1"
    >
      <TextField
        placeholder="Operation or admission"
        value={formData.reason}
        onChange={(event) => {
          setFormData((prev) => ({
            ...prev,
            reason: event.target.value,
          }));
          setCombineAnswer();
        }}
        onBlur={(event) => {
          setFormData((prev) => ({
            ...prev,
            reason: event.target.value,
          }));
          setCombineAnswer();
        }}
        type="text"
        fullWidth
        sx={{ mb: 2 }}
      />
      <Select
        placeholder="Select a Year"
        onChange={(event) => {
          setFormData((prev) => ({ ...prev, year: event.target.value }));
          setCombineAnswer();
        }}
        value={formData.year}
        displayEmpty
        inputProps={{ 'aria-label': 'Without label' }}
        sx={{ mb: 2 }}
      >
        <MenuItem disabled value="">
          Select a Year
        </MenuItem>
        {years.map((year) => (
          <MenuItem key={year} value={year}>
            {year}
          </MenuItem>
        ))}
      </Select>
      <TextField
        placeholder="Hospital"
        value={formData.hospital}
        onChange={(event) => {
          setFormData((prev) => ({
            ...prev,
            hospital: event.target.value,
          }));
          setCombineAnswer();
        }}
        onBlur={(event) => {
          setFormData((prev) => ({
            ...prev,
            hospital: event.target.value,
          }));
          setCombineAnswer();
        }}
        type="text"
        fullWidth
        sx={{ mb: 2 }}
      />
    </Box>
  );
};

export default MultiText;
